import {SCRIPT_PAGE,type PrintLine,type ScriptLayout} from './scriptLayout';

export const DRAFT_PAGE_GAP=24;
export interface DraftLine extends PrintLine {top:number;page:number}
export interface DraftBlock {top:number;height:number;fields:Map<string,DraftLine[]>}
export interface DraftLayout {height:number;pages:number;blocks:Map<string,DraftBlock>;markers:DraftLine[]}

/** Display projection only: source ranges and saved paragraphs stay unchanged. */
export function projectDraftLayout(layout:ScriptLayout):DraftLayout {
    const blocks=new Map<string,DraftBlock>(),markers:DraftLine[]=[];
    for(const page of layout.pages)for(const line of page.lines){
        const top=(page.pageNumber-1)*(SCRIPT_PAGE.height+DRAFT_PAGE_GAP)+line.y-(line.ascent??SCRIPT_PAGE.fontSize*.8);
        const projected={...line,top,page:page.pageNumber};
        if(line.kind!=='content'){markers.push(projected);continue;}
        let block=blocks.get(line.blockId);
        if(!block){block={top,height:line.lineHeight??SCRIPT_PAGE.lineHeight,fields:new Map()};blocks.set(line.blockId,block);}
        block.height=Math.max(block.height,top-block.top+(line.lineHeight??SCRIPT_PAGE.lineHeight));
        const field=block.fields.get(line.field)??[];field.push(projected);block.fields.set(line.field,field);
    }
    return {blocks,markers,pages:layout.pages.length,height:layout.pages.length*SCRIPT_PAGE.height+Math.max(0,layout.pages.length-1)*DRAFT_PAGE_GAP};
}
